export const ARCHIVE = 'PROJECT/ARCHIVE';
export const EDIT = 'PROJECT/EDIT';
export const CREATE = 'PROJECTS/CREATE';
export const ERROR = 'PROJECT/ERROR';
export const FETCH = 'PROJECT/FETCH';
export const LOADING = 'PROJECT/LOADING';
export const LOCK = 'PROJECT/LOCK';
export const SET_DATA = 'PROJECT/SET_DATA';
export const SET_METADATA_VIEW = 'PROJECT/SET_METADATA_VIEW';
export const UNLOCK = 'PROJECT/UNLOCK';
export const CLOSE = 'PROJECT/CLOSE';
export const CONDITIONALLY_CLOSE = 'PROJECT/CONDITIONALLY_CLOSE';
export const DROP = 'PROJECT/DROP';
export const FETCH_LATEST_STATUS = 'PROJECT/FETCH_LATEST_STATUS';
export const SET_LATEST_STATUS = 'PROJECT/SET_LATEST_STATUS';
export const FETCH_STATUS_HISTORY = 'PROJECT/FETCH_STATUS_HISTORY';
export const SET_STATUS_HISTORY = 'PROJECT/SET_STATUS_HISTORY';
export const APPEND_STATUS_HISTORY = 'PROJECT/APPEND_STATUS_HISTORY';
export const RESET_STATUS_HISTORY = 'PROJECT/RESET_STATUS_HISTORY';
export const STATUS_LOADING = 'PROJECT/STATUS_LOADING';
export const STATUS_ERROR = 'PROJECT/STATUS_ERROR';
export const FETCH_RECIPIENTS = 'PROJECT/FETCH_RECIPIENTS';
export const SET_RECIPIENTS = 'PROJECT/SET_RECIPIENTS';
export const FETCH_PROJECT_EMAIL_NOTIFICATION_HISTORY = 'PROJECT/FETCH_PROJECT_EMAIL_NOTIFICATION_HISTORY';
export const SET_PROJECT_EMAIL_NOTIFICATION_HISTORY = 'PROJECT/SET_PROJECT_EMAIL_NOTIFICATION_HISTORY';
/* TODO remove history argument once react connected router supports */
/* redux 7+ */
export const archive = (id, history) => ({ type: ARCHIVE, id, history });
export const edit = history => ({ type: EDIT, history });
export const create = history => ({ type: CREATE, history });
export const error = err => ({ type: ERROR, error: err });
export const fetch = closing_id => ({ type: FETCH, closing_id });
export const loading = isLoading => ({ type: LOADING, loading: isLoading });
export const setData = data => ({ type: SET_DATA, data });
export const setMetaDataView = (metaDataView, document) => ({
  type: SET_METADATA_VIEW, metaDataView, document,
});
export const unlock = (closing_id, history, projectOpen) => ({ type: UNLOCK, closing_id, history, projectOpen });
export const lock = (closing_id, history, projectOpen) => ({ type: LOCK, closing_id, history, projectOpen });
export const close = (closing_id, history, projectOpen, desk_audit_closing_actual_date) => ({ type: CLOSE, closing_id, history, projectOpen, desk_audit_closing_actual_date });
export const conditionallyClose = (closing_id, history, projectOpen) => ({ type: CONDITIONALLY_CLOSE, closing_id, history, projectOpen });
export const drop = (closing_id, history, projectOpen) => ({ type: DROP, closing_id, history, projectOpen });
export const fetchLatestStatus = closing_id => ({ type: FETCH_LATEST_STATUS, closing_id });
export const setLatestStatus = data => ({ type: SET_LATEST_STATUS, data });
export const fetchStatusHistory = (closing_id, limit, page, sortField, sortDirection) => ({ 
  type: FETCH_STATUS_HISTORY, 
  closing_id, 
  limit, 
  page,
  sortField,
  sortDirection
});
export const setStatusHistory = (records, totalCount) => ({ 
  type: SET_STATUS_HISTORY, 
  records, 
  totalCount 
});
export const appendStatusHistory = (records, totalCount) => ({ 
  type: APPEND_STATUS_HISTORY, 
  records, 
  totalCount 
});
export const resetStatusHistory = () => ({ type: RESET_STATUS_HISTORY });
export const statusLoading = isLoading => ({ type: STATUS_LOADING, loading: isLoading });
export const statusError = err => ({ type: STATUS_ERROR, error: err });
export const fetchRecipients = closing_id => ({ type: FETCH_RECIPIENTS, closing_id });
export const setRecipients = recipients => ({ type: SET_RECIPIENTS, recipients });  
export const SEND_EMAIL_NOTIFICATION = 'PROJECT/SEND_EMAIL_NOTIFICATION';
export const SEND_EMAIL_NOTIFICATION_SUCCESS = 'PROJECT/SEND_EMAIL_NOTIFICATION_SUCCESS';
export const SEND_EMAIL_NOTIFICATION_ERROR = 'PROJECT/SEND_EMAIL_NOTIFICATION_ERROR';
export const RESET_EMAIL_NOTIFICATION_SEND_STATUS = 'PROJECT/RESET_EMAIL_NOTIFICATION_SEND_STATUS';
export const fetchProjectEmailNotificationHistory = closing_id => ({ type: FETCH_PROJECT_EMAIL_NOTIFICATION_HISTORY, closing_id });
export const setProjectEmailNotificationHistory = history => ({ type: SET_PROJECT_EMAIL_NOTIFICATION_HISTORY, history });
export const sendEmailNotification = (closing_id, recipients, subject, htmlContent) => ({ type: SEND_EMAIL_NOTIFICATION, closing_id, recipients, subject, htmlContent });
export const sendEmailNotificationSuccess = response => ({ type: SEND_EMAIL_NOTIFICATION_SUCCESS, response });
export const sendEmailNotificationError = error => ({ type: SEND_EMAIL_NOTIFICATION_ERROR, error });
export const resetEmailNotificationSendStatus = () => ({ type: RESET_EMAIL_NOTIFICATION_SEND_STATUS });
